<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('rappers.edit', { id: vm.$route.params.rapperId })
  }),
  computed: {
    ...mapState('rappers', ['routeKey', 'routes', 'form', 'item']),
    crumbs: vm => [
      { text: vm.$t('rappers.title'), to: { name: 'rappers.index' } },
      { text: vm.$t('rappers.edit', { id: vm.$route.params.rapperId }) }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('rappers/fetchItem', { route: to })
      await store.dispatch('rappers/fetchSiteVersions')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('rappers', ['createItem', 'updateItem'])
  }
}
</script>
